import React from 'react';

const EnquiryConfirmation = ({ isSpecialJourney }) => {  

    return (
        <>
            <style>
                {`

                
                `}
            </style>

            <div style={{display: 'flex'}}>
                <div>
                    <h3 className="mt-3">Thank you for your enquiry</h3>
                    <p>Your enquiry has been sent to the restaurant. We aim to get back to you within 24 hours.</p>
                    {!isSpecialJourney && (
                        <>
                            <p>While we attend your enquiry, we invite you to explore our menus, brimming with authentic Italian dishes and drinks.</p>
                            <button onClick={() => {window.location = "/a-la-carte"}}>View Menus</button>
                        </>
                    )}
                </div>
                <div>
                    <img></img>
                </div>
            </div>
            
        </>);

}

export default EnquiryConfirmation;